import { render } from "./FooterOrderNew.vue?vue&type=template&id=5cf36e37&scoped=true"
import script from "./FooterOrderNew.vue?vue&type=script&lang=js"
export * from "./FooterOrderNew.vue?vue&type=script&lang=js"

import "./FooterOrderNew.vue?vue&type=style&index=0&id=5cf36e37&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf36e37"]])

export default __exports__